import { render, staticRenderFns } from "./Flevoland.vue?vue&type=template&id=1d32e5d7&"
var script = {}
import style0 from "./Flevoland.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Flevoland.vue"
export default component.exports